import { defineStore } from "pinia";
import type EntityParameterSettings from "@/interfaces/Parameters/EntityParameterSettings";
import type ParameterSettings from "@/interfaces/Parameters/ParameterSettings";
import {
  getEntityParameterSettings,
  getParameterSettings,
} from "@/repositories/Parameters/ParameterRepository";

export const useParametersStore = defineStore("parameters", {
  state: () => ({
    parameterSettings: {} as ParameterSettings,
    isLoaded: false,
    isLoading: false,
    entityParameterSettings: {} as EntityParameterSettings,
    entityParametersIsLoaded: false,
    entityParametersIsLoading: false,
  }),
  getters: {
    isEntityParametersLoaded(state) {
      return state.entityParametersIsLoaded;
    },
    isAnyLoading(state) {
      return state.isLoading || state.entityParametersIsLoading;
    },
  },
  actions: {
    async loadParameterSettings(force = false) {
      if (this.isLoading || (this.isLoaded && !force)) {
        return this.parameterSettings;
      }

      this.isLoading = true;

      try {
        const response = await getParameterSettings();
        this.parameterSettings = { ...response };
        this.isLoaded = true;

        return this.parameterSettings;
      } finally {
        this.isLoading = false;
      }
    },
    async loadEntityParameterSettings(force = false) {
      if (
        this.entityParametersIsLoading ||
        (this.entityParametersIsLoaded && !force)
      ) {
        return this.entityParameterSettings;
      }

      this.entityParametersIsLoading = true;

      try {
        const response = await getEntityParameterSettings();
        this.entityParameterSettings = { ...response };
        this.entityParametersIsLoaded = true;

        return this.entityParameterSettings;
      } finally {
        this.entityParametersIsLoading = false;
      }
    },
    clearEntityParameterSettings() {
      this.entityParameterSettings = {} as EntityParameterSettings;
      this.entityParametersIsLoaded = false;
      this.entityParametersIsLoading = false;
    },
  },
});
